import React, { useRef, useState, useEffect } from "react";

export const EegTrace: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.3 },
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);
  const jaggedPath =
    "M0,32 L10,28 L18,38 L26,20 L34,42 L42,16 L50,40 L58,24 L66,36 L74,18 L82,44 L90,22 L98,34 L106,26 L114,38 L122,20 L130,42 L138,24 L146,30 L154,22 L162,36 L170,18 L178,40 L186,26 L194,34 L202,20 L210,38 L218,24 L226,32 L234,28 L242,36 L250,22 L258,40 L266,26 L274,30 L282,20 L290,38 L298,24 L306,32 L314,28 L322,34 L330,22 L338,40 L346,26 L354,30 L362,24 L370,36 L378,22 L386,38 L394,28 L402,30 L410,26 L418,32 L426,24 L434,34 L442,28 L450,30 L458,27 L466,29 L474,28 L482,29 L490,28 L498,29 L506,28 L514,29 L522,28 L530,29 L538,28 L546,29 L554,28 L562,28.5 L570,29 L578,28 L586,28.5 L594,28.5 L602,28.5 L610,28.5 L618,28.5 L626,28.5 L634,28.5 L642,28.5 L650,28.5 L658,28.5 L666,28.5 L674,28.5 L682,28.5 L690,28.5 L698,28.5 L706,28.5 L714,28.5 L722,28.5 L730,28.5 L738,28.5 L746,28.5 L754,28.5 L762,28.5 L770,28.5 L778,28.5 L786,28.5 L794,28.5 L800,28.5";
  return (
    <div ref={containerRef} className="prism-eeg" aria-hidden="true">
      <svg
        viewBox="0 0 800 56"
        preserveAspectRatio="none"
        className="h-full w-full"
      >
        <path d={jaggedPath} className="prism-eeg-line" />
        <rect
          x="0"
          y="0"
          width="800"
          height="56"
          fill="#071D33"
          className={visible ? "prism-eeg-mask" : ""}
          style={visible ? undefined : { transform: "translateX(0)" }}
        />
        <path
          d="M0,28.5 L800,28.5"
          fill="none"
          stroke="#2F6F9F"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
